import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeButtonModule } from 'se-fe-button'

import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsTableModule } from 'se-fe-docs-table'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SeFeToastModule } from 'se-fe-toast'
import { SharedUiPersonaInfoModule } from '../lib/shared-ui-persona-info.module'
import { PersonaInfoDocsComponent } from './persona-info-docs/persona-info-docs.component'
import { PersonaInfoExampleComponent } from './persona-info-docs/persona-info-example.component'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'

@NgModule({
  declarations: [
    PersonaInfoDocsComponent,
    PersonaInfoExampleComponent
  ],
  exports: [
    PersonaInfoDocsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeHeaderModule,
    SeFePageModule,
    SeFeToastModule,
    SharedUiPersonaInfoModule
  ],
})
export class SharedUiPersonaInfoDocsModule { }
